import { getOpCoMetaConfig, Iata } from '@reward-platform/platform-config'

const IMPERIAL_UNIT_COUNTRIES = ['GB', 'US']

export const shouldUseImperialUnits = (userCountry: string | undefined, opCo: Iata) =>
  !getOpCoMetaConfig(opCo).isMetricOnly && IMPERIAL_UNIT_COUNTRIES.includes(userCountry ?? '')
